import { inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { TaasUserDetails } from 'utimaco-common-ui-angular';
import { TaasJwtTokenDetails } from '../models/taas-jwt-token-details';

@Injectable({
  providedIn: 'root'
})
export class TaasUserService {
  private keycloakService: KeycloakService = inject(KeycloakService);

  public currentuser: TaasUserDetails = {
    givenName: "",
    familyName: "",
    email: "",
    initials: "",
    roles: []
  };
  
  /**
   * fetch the current user details from keycloak token and update the internal currentUser insance in the service
   * @returns Promise<TaasUserDetails> with updated TaasUserDetails instance
   */
  async getCurrentUserDetails(): Promise<TaasUserDetails> {
    const tokenString = await this.keycloakService.getToken();
    const tokenObject: TaasJwtTokenDetails = JSON.parse(atob(tokenString.split('.')[1]));
    this.currentuser.givenName = tokenObject.given_name;
    this.currentuser.familyName = tokenObject.family_name;
    this.currentuser.email = tokenObject.email;
    this.currentuser.initials = tokenObject.given_name.trim().substring(0, 1) + tokenObject.family_name.trim().substring(0, 1);
    this.currentuser.roles = tokenObject.realm_access.roles;
    return this.currentuser;
  }
}
